import React from 'react'

import {
  AlignItems,
  Box,
  Color,
  Display,
  DisplayPosition,
  JustifyContent,
  Space,
  ZIndex,
} from '@gousto-internal/citrus-react'

import * as trackingKeys from 'actions/trackingKeys'
import type { View } from 'utils/view'

import { BrowseCTAContainer } from '../../BrowseCTA'
import { BrowseCTAButtonContainer } from '../../BrowseCTAButton'
import { BasketComprehensionSummary } from '../BasketComprehensionSummary'
import { CheckoutButton } from '../CheckoutButton'

type Props = {
  showBrowseCTA: boolean
  view: View
}

export const BasketComprehensionBanner = ({ showBrowseCTA, view }: Props) => {
  return (
    <section>
      <Box
        alignItems={AlignItems.Center}
        bg={Color.ColdGrey_800}
        bottom="0"
        boxShadow="0px -4px 8px rgba(0, 0, 0, 0.16)"
        display={Display.Flex}
        height="64px"
        left="0"
        paddingH={[3, null, 8]}
        position={DisplayPosition.Fixed}
        width="100%"
        zIndex={ZIndex.Toast}
      >
        <Box
          alignItems={AlignItems.Center}
          display={Display.Flex}
          height="100%"
          justifyContent={[JustifyContent.SpaceBetween, null, JustifyContent.FlexEnd]}
          width="100%"
          data-no-code="boxSummaryPriceContainer"
        >
          <BasketComprehensionSummary />

          {showBrowseCTA ? (
            <>
              <BrowseCTAButtonContainer view={view} />
              <BrowseCTAContainer view={view} />
            </>
          ) : (
            <>
              <Space direction="horizontal" size={4} />
              <CheckoutButton
                view={view}
                section={trackingKeys.menu}
                hideCounter
                isBasketComprehensionEnabled
              />
            </>
          )}
        </Box>
      </Box>
    </section>
  )
}
